import styled from "@emotion/styled";
import { css } from "@emotion/core";
import { transparentize } from "../../../utils/helpers/transparentize";
import { theme as nectar } from "nectar-ui";

const theme = nectar.standard;

const inputHeights = { sm: "28px", md: "38px" };

export const globalStyle = css`
  .DateInput_fang {
    top: 45px !important;
  }
  .CalendarDay__default,
  .CalendarDay__default:hover {
    border: unset;
  }

  .DayPicker_weekHeader_ul {
    font-weight: ${theme.fontWeight.semiBold};
  }

  .CalendarMonth_table .CalendarDay__selected,
  .CalendarMonth_table .CalendarDay__selected:hover {
    border: unset;
  }
  .SingleDatePicker_picker,
  .DateRangePicker_picker {
    top: 55px !important;
    border: 0;
    box-shadow: 0 1px 4px 1px rgba(52, 58, 64, 0.2);
    border-radius: 3px;
  }
  .DayPicker__withBorder {
    box-shadow: 0 0 0 transparent;
  }

  .CalendarDay {
    vertical-align: middle;
    border-radius: ${theme.borderRadius.md};
    font-weight: ${theme.fontWeight.semiBold};
    transition: ease 0.3s all;
  }
  .CalendarDay__selected_span {
    background: ${theme.colors.primary100};
    color: ${theme.colors.primary900};
  }
  .CalendarDay__selected_span:hover {
    background: ${theme.colors.primary300};
    color: ${theme.colors.primary700};
  }

  .CalendarDay__selected,
  .CalendarDay__selected:hover {
    background: ${theme.colors.primary};
  }

  .CalendarDay__hovered_span:hover,
  .CalendarDay__hovered_span {
    background: ${theme.colors.primary100};
    color: ${theme.colors.primary700};
  }

  .CalendarDay__today:not(.CalendarDay__selected) {
    color: ${theme.colors.primary};
    font-weight: bold;
  }
  .SingleDatePicker_picker__portal {
    z-index: 9;
    top: 0 !important;
  }
`;

interface DatePickerProps {
  validate?: string;
  isOpen?: boolean;
  showInput?: boolean;
  size?: string;
}

const Single = styled("div")<DatePickerProps>`
  ${({ validate, isOpen, showInput, size }) => css`
    .SingleDatePicker {
      display: block;
    }

    .SingleDatePickerInput {
      position: relative;
      display: ${showInput ? "block" : "none !important"};
    }

    .SingleDatePickerInput svg {
      transition: all ${theme.transition};
      fill: ${validate ? theme.colors[validate] : theme.colors.gray500};
    }
    .SingleDatePickerInput:hover svg {
      fill: ${validate ? theme.colors[validate] : theme.colors.primary};
    }
    ${isOpen &&
    `
      .SingleDatePickerInput svg {
        fill: 
          ${validate ? theme.colors[validate] : theme.colors.primary};
      }
    `};

    .SingleDatePickerInput_calendarIcon {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      outline: none;
      padding: 0 0.625rem;
    }

    .DateInput_fangStroke {
      stroke: ${theme.colors.gray100};
    }

    .SingleDatePicker .DateInput {
      display: block;
      width: 100%;
    }

    .SingleDatePicker .DateInput_input,
    .DateRangePickerInput {
      -moz-appearance: textfield;
      -webkit-appearance: none;
      display: block;
      width: 100%;
      border: 1px solid ${validate ? theme.colors[validate] : theme.colors.gray300};
      background: white;
      border-radius: 4px;
      padding: 0.5rem 0.625rem;
      height: ${inputHeights[size as keyof typeof inputHeights]};
      background: white;
      font-size: ${theme.typography.text.md};
      color: ${validate ? theme.colors[validate] : theme.colors.gray900};
      transition: all ${theme.transition};
      outline: none;
    }

    .DateRangePickerInput {
      display: flex;
      align-items: center;
      padding: 0;
    }
    .DateRangePickerInput .DateInput {
      width: 5.625rem;
      background: transparent;
    }
    .DateRangePickerInput .DateInput_input {
      padding: 0.5rem 0.625rem;
      outline: none;
      font-weight: normal;
      font-size: ${theme.typography.text.sm};
      color: ${validate ? theme.colors[validate] : theme.colors.gray500};
      height: ${theme.form.heightSize.md};
      background: transparent;
      border: 0;
    }

    .DateRangePicker__block .DateRangePickerInput_calendarIcon {
      flex: 1;
      text-align: right;
    }

    .DateInput_input::-webkit-input-placeholder,
    .DateInput_input::-moz-placeholder,
    .DateInput_input:-ms-input-placeholder,
    .DateInput_input:-moz-placeholder {
      color: ${theme.colors.gray500};
    }

    .SingleDatePicker .DateInput_input:hover,
    .SingleDatePicker .DateInput_input:focus,
    .SingleDatePicker .SingleDatePickerInput:hover .DateInput_input,
    .DateRangePickerInput:hover {
      border-color: ${validate ? theme.colors[validate] : theme.colors.primaryHover};
    }

    ${isOpen &&
    `
      .SingleDatePicker .DateInput_input {
        border-color: ${
          validate
            ? transparentize(theme.colors[validate], 0.3)
            : transparentize(theme.colors.primary, 0.3)
        };
      }
    `};

    .SingleDatePicker .DateInput_input:focus {
      box-shadow: 0 0 0 0.125rem
        ${validate
          ? transparentize(theme.colors[validate], 0.3)
          : transparentize(theme.colors.primary, 0.3)};
    }

    ${isOpen &&
    `
      .DateInput_input {
        box-shadow: 0 0 0 0.125rem rgba(128, 199, 234,.3);
      }
    `};

    .SingleDatePicker .DateInput_input:read-only:hover,
    .SingleDatePicker .DateInput_input:read-only:focus {
      border-color: ${validate ? theme.colors[validate] : theme.colors.gray300};
      box-shadow: 0 0 0 0 transparent;
    }

    .DateRangePickerInput_arrow_svg {
      fill: ${theme.colors.gray500};
      width: 20px;
    }

    .DateRangePickerInput_calendarIcon {
      margin-left: 0;
    }
    .DateRangePickerInput_calendarIcon:hover .DateRangePickerInput_calendarIcon_svg {
      fill: ${validate ? theme.colors[validate] : theme.colors.primary};
    }
  `};
`;

export default Single;
